import { useEffect, useRef } from 'react';

import { GradientBackgroundRoot } from './GradientBackgroundFinance.styles';

export const GradientBackgroundFinance = () => {
  const interactiveRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interactiveElement = interactiveRef.current;

    function move(event: MouseEvent) {
      if (!interactiveElement) return;

      interactiveElement.style.transform = `translate(${Math.round(
        event.clientX
      )}px, ${Math.round(event.clientY)}px)`;
    }

    window.addEventListener('mousemove', move);

    return () => {
      window.removeEventListener('mousemove', move);
    };
  }, []);

  return (
    <GradientBackgroundRoot>
      <div className="fill-bg" />
      <svg xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="goo">
            <feGaussianBlur
              in="SourceGraphic"
              result="blur"
              stdDeviation="10"
            />
            <feColorMatrix
              in="blur"
              mode="matrix"
              result="goo"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8"
            />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>
      <div className="gradients-container">
        <div className="g1" />
        <div className="g2" />
        <div className="g3" />
        <div className="g4" />
        <div className="g5" />
        <div ref={interactiveRef} className="interactive" />
      </div>
    </GradientBackgroundRoot>
  );
};
